// extracted by mini-css-extract-plugin
module.exports = {"root":"ModalUpdate_root__2ZNPj","footer":"ModalUpdate_footer__cv1Ww"};